<template>
  <div class="modal fade" id="modalNuevoRegistro" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog" style="max-width: 90vw;">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="crearRegistroModalLabel">Crear Nuevo Registro</h5>
          <button type="button" class="btn-close" @click="cerrarModal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <!-- Columna izquierda: Drag and drop -->
            <div class="col-8 h-100">
              <div class="border rounded p-3 text-center h-100" @drop.prevent="handleDrop" @dragover.prevent
                @dragleave.prevent :class="{ 'bg-light': isDragging }">
                <div class="h-100 d-flex flex-column justify-content-center" v-if="!archivo.value"
                  style="min-height: 80vh">
                  <label class="labelFile" @click="triggerFileInput">
                    <span>
                      <svg xml:space="preserve" viewBox="0 0 184.69 184.69"
                        xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" id="Capa_1"
                        version="1.1" width="60px" height="60px">
                        <g>
                          <g>
                            <g>
                              <path
                                d="M149.968,50.186c-8.017-14.308-23.796-22.515-40.717-19.813 C102.609,16.43,88.713,7.576,73.087,7.576c-22.117,0-40.112,17.994-40.112,40.115c0,0.913,0.036,1.854,0.118,2.834 C14.004,54.875,0,72.11,0,91.959c0,23.456,19.082,42.535,42.538,42.535h33.623v-7.025H42.538 c-19.583,0-35.509-15.929-35.509-35.509c0-17.526,13.084-32.621,30.442-35.105c0.931-0.132,1.768-0.633,2.326-1.392 c0.555-0.755,0.795-1.704,0.644-2.63c-0.297-1.904-0.447-3.582-0.447-5.139c0-18.249,14.852-33.094,33.094-33.094 c13.703,0,25.789,8.26,30.803,21.04c0.63,1.621,2.351,2.534,4.058,2.14c15.425-3.568,29.919,3.883,36.604,17.168 c0.508,1.027,1.503,1.736,2.641,1.897c17.368,2.473,30.481,17.569,30.481,35.112c0,19.58-15.937,35.509-35.52,35.509H97.391 v7.025h44.761c23.459,0,42.538-19.079,42.538-42.535C184.69,71.545,169.884,53.901,149.968,50.186z"
                                style="fill:#010002;"></path>
                            </g>
                            <g>
                              <path
                                d="M108.586,90.201c1.406-1.403,1.406-3.672,0-5.075L88.541,65.078 c-0.701-0.698-1.614-1.045-2.534-1.045l-0.064,0.011c-0.018,0-0.036-0.011-0.054-0.011c-0.931,0-1.85,0.361-2.534,1.045 L63.31,85.127c-1.403,1.403-1.403,3.672,0,5.075c1.403,1.406,3.672,1.406,5.075,0L82.296,76.29v97.227 c0,1.99,1.603,3.597,3.593,3.597c1.979,0,3.59-1.607,3.59-3.597V76.165l14.033,14.036 C104.91,91.608,107.183,91.608,108.586,90.201z"
                                style="fill:#010002;"></path>
                            </g>
                          </g>
                        </g>
                      </svg>
                    </span>
                    <p>Arrastra y suelta un archivo aquí o haz clic para subirlo!</p>
                  </label>
                  <input type="file" class="d-none" ref="fileInput" @change="handleFileInput" />
                </div>
                <div v-if="archivo.value" style="min-height: 80vh">
                  <!-- Visualización del contenido -->
                  <div v-if="modalFileType === 'pdf'" class="pdf-container">
                    <vue-office-pdf v-if="modalPdfSrc" :src="modalPdfSrc" style="height: 70vh;" />
                  </div>
                  <div v-else-if="modalFileType === 'image'" class="image-container">
                    <img :src="modalImgbase64" alt="Vista previa del archivo" style="max-height: 100%; width: auto;" />
                  </div>
                  <div v-else-if="modalFileType === 'text'" class="file-container">
                    <pre style="white-space: pre-wrap; font-family: inherit; background: none; border: 1px solid #e9ecef; border-radius: 6px; padding: 12px; min-height: 50vh;">
                      {{ modalTextContent }}</pre>
                  </div>
                  <vue-office-docx v-else-if="modalFileType === 'docx'" :src="modalDocxSrc" style="height: 70vh;" />
                  <vue-office-excel v-else-if="modalFileType === 'xlsx'" :src="modalExcelSrc" style="height: 70vh;" />
                  <vue-office-pptx v-else-if="modalFileType === 'pptx'" :src="modalPptxSrc" style="height: 70vh;" />
                  <div v-else-if="modalFileType === 'dwg'"
                    style="min-height: 100px; min-width: 100px;"
                    class="dwg-container"
                    :style="{ 
                      width: '100%', 
                      height: '70vh',
                      display: 'block',
                      position: 'relative'
                    }">
                    <VisorCAD2 
                      :base64="modalDwgBase64 || ''" 
                      :is-fullscreen="false"
                      @error="(msg) => showNotification(msg, 'alert-danger')"
                    />
                  </div>
                  <div v-else class="file-container">
                    <p>El archivo no se puede previsualizar.</p>
                  </div>
                  <button class="btn btn-danger mt-3" @click="eliminarArchivo">Eliminar Archivo</button>
                </div>
              </div>
            </div>

            <!-- Columna derecha: Formulario -->
            <div class="col-4">
              <form @submit.prevent="crearRegistro" v-if="esquema.propiedades">
                <div class="accordion" id="accordionPropiedadesNuevo" :class="{ 'accordion-dropdown-open': openListCampo }">
                  <div v-for="(grupo, index) in propiedadesAgrupadas" :key="'grupo_nuevo_' + grupo.nombre"
                    class="accordion-item">
                    <h2 class="accordion-header" :id="'headingNuevo' + index">
                      <button class="accordion-button" type="button" data-bs-toggle="collapse"
                        :data-bs-target="'#collapseNuevo' + index" aria-expanded="true"
                        :aria-controls="'collapseNuevo' + index">
                        {{ grupo.nombre || 'Sin grupo' }}
                        <small class="text-muted ms-2">({{ grupo.propiedades.length }})</small>
                      </button>
                    </h2>
                    <div :id="'collapseNuevo' + index" class="accordion-collapse collapse show"
                      :aria-labelledby="'headingNuevo' + index" data-bs-parent="#accordionPropiedadesNuevo">
                      <div class="accordion-body">
                        <div v-for="propiedad in grupo.propiedades" :key="'nuevo_' + propiedad.id" class="form-group mb-3">
                          <label class="form-control-label">{{ formatearNombrePropiedad(propiedad.nombre) }}</label>
                          <template v-if="propiedad.tipo === 'text'">
                            <input class="form-control" style="min-height: 45px" type="text"
                              v-model="nuevoRegistro.value[propiedad.campoBD]">
                          </template>
                          <template v-else-if="propiedad.tipo === 'longtext'">
                            <textarea class="form-control" style="min-height: 100px"
                              v-model="nuevoRegistro.value[propiedad.campoBD]"></textarea>
                          </template>
                          <template v-else-if="propiedad.tipo === 'int'">
                            <input class="form-control" style="min-height: 45px" type="number" step="1"
                              v-model.number="nuevoRegistro.value[propiedad.campoBD]">
                          </template>
                          <template v-else-if="propiedad.tipo === 'decimal'">
                            <input class="form-control" style="min-height: 45px" type="number" step="0.00000001"
                              :value="nuevoRegistro.value[propiedad.campoBD]"
                              @input="handleDecimalInput(propiedad.campoBD, $event)"
                              @blur="formatDecimalOnBlur(propiedad.campoBD, 8)">
                          </template>
                          <template v-else-if="propiedad.tipo === 'decimal2'">
                            <input class="form-control" style="min-height: 45px" type="number" step="0.01"
                              v-model="nuevoRegistro.value[propiedad.campoBD]"
                              @blur="formatDecimalOnBlur(propiedad.campoBD, 2)">
                          </template>
                          <template v-else-if="propiedad.tipo === 'decimal4'">
                            <input class="form-control" style="min-height: 45px" type="number" step="0.0001"
                              v-model="nuevoRegistro.value[propiedad.campoBD]"
                              @blur="formatDecimalOnBlur(propiedad.campoBD, 4)">
                          </template>
                          <template v-else-if="propiedad.tipo === 'date'">
                            <input class="form-control" style="min-height: 45px" type="date"
                              v-model="nuevoRegistro.value[propiedad.campoBD]">
                          </template>
                          <template v-else-if="propiedad.tipo === 'list'">
                            <div class="position-relative" :class="{ 'list-dropdown-open': openListCampo === propiedad.campoBD }">
                              <div class="form-control d-flex align-items-center justify-content-between"
                                style="min-height: 45px; cursor: pointer;"
                                @click="toggleListDropdown(propiedad)">
                                <span class="text-truncate">{{ nuevoRegistro.value[propiedad.campoBD] || 'Selecciona una opción' }}</span>
                                <i class="fas fa-chevron-down ms-2 flex-shrink-0"></i>
                              </div>
                              <div v-show="openListCampo === propiedad.campoBD"
                                :data-list-dropdown-modal="propiedad.campoBD"
                                class="border rounded shadow-sm position-absolute start-0 end-0 mt-1 bg-white"
                                style="z-index: 1200; max-height: 280px;">
                                <input type="text"
                                  class="form-control form-control-sm m-2"
                                  placeholder="Buscar..."
                                  v-model="listFilterText"
                                  @keydown.escape="openListCampo = null"
                                  @click.stop>
                                <ul class="list-group list-group-flush" style="max-height: 220px; overflow-y: auto;">
                                  <li v-for="valor in valoresListaFiltrados(propiedad)" :key="valor.id"
                                    class="list-group-item list-group-item-action py-2"
                                    @click="selectValorLista(propiedad, valor)">
                                    {{ valor.descripcion }}
                                  </li>
                                  <li v-if="valoresListaFiltrados(propiedad).length === 0" class="list-group-item text-muted small">Sin resultados</li>
                                </ul>
                              </div>
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-items-center mt-4">
                  <button type="submit" class="btn btn-success">Guardar</button>
                  <button type="button" class="btn btn-secondary ms-2" data-bs-dismiss="modal">Cancelar</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, computed, defineExpose, onMounted, onBeforeUnmount, nextTick, watch } from 'vue'
import VueOfficePdf from '@vue-office/pdf'
import VueOfficeDocx from '@vue-office/docx'
import VueOfficeExcel from '@vue-office/excel'
import VueOfficePptx from '@vue-office/pptx'
import '@vue-office/docx/lib/index.css'
import '@vue-office/excel/lib/index.css'
import axiosInstance from "@/axios"
import VisorCAD2 from "@/components/VisorCAD2.vue"

export default {
  name: 'NuevoRegistroModal',
  components: { VueOfficeDocx, VueOfficeExcel, VueOfficePdf, VueOfficePptx, VisorCAD2 },
  props: {
    esquema: {
      type: Object,
      required: true
    },
    listasDisponibles: {
      type: Array,
      default: () => []
    },
    showNotification: {
      type: Function,
      required: true
    }
  },
  emits: ['crear-registro', 'cerrar-modal', 'limpiar-formulario'],
  setup(props, { emit }) {
    const archivo = reactive({})
    const isDragging = reactive(false)
    const fileInput = ref(null)
    const nuevoRegistro = reactive({})
    
    // Cache para valores de listas (listaId -> valores[])
    const valoresListasCache = ref({})
    const valoresListasPending = ref({})
    // Selector de lista con búsqueda
    const openListCampo = ref(null)
    const listFilterText = ref('')
    let listOutsideClickHandler = null
    let listOutsideClickTimeout = null
    const clearListOutsideClick = () => {
      if (listOutsideClickTimeout) {
        clearTimeout(listOutsideClickTimeout)
        listOutsideClickTimeout = null
      }
      if (listOutsideClickHandler) {
        document.removeEventListener('click', listOutsideClickHandler)
        listOutsideClickHandler = null
      }
    }

    // Variables para visores del modal
    const modalFileType = ref('')
    const modalDwgBase64 = ref('')
    const modalTextContent = ref('')
    const modalDocxSrc = ref('')
    const modalExcelSrc = ref('')
    const modalPptxSrc = ref('')
    const modalPdfSrc = ref('')
    const modalImgbase64 = ref('')

    const triggerFileInput = () => {
      fileInput.value.click()
    }

    const handleDrop = (event) => {
      const file = event.dataTransfer.files[0]
      procesarArchivo(file)
    }

    const handleFileInput = (event) => {
      const file = event.target.files[0]
      procesarArchivo(file)
    }

    const procesarArchivo = (file) => {
      if (!file) return

      const reader = new FileReader()

      reader.onload = () => {
        const base64 = reader.result
        const url = URL.createObjectURL(file)

        archivo.value = {
          nombre: file.name,
          tipo: file.type,
          url: url,
          base64: base64,
        }

        // Preparar visores para el modal
        const extension = file.name.split('.').pop().toLowerCase()
        modalFileType.value = getFileTypeFromExtension(extension)

        // Limpiar visores anteriores
        modalTextContent.value = ''
        modalDocxSrc.value = ''
        modalExcelSrc.value = ''
        modalPptxSrc.value = ''
        modalPdfSrc.value = ''
        modalImgbase64.value = ''
        modalDwgBase64.value = ''

        // Extraer solo la parte base64 sin el prefijo data:image/...;base64,
        const base64Data = base64.split(',')[1]

        // Preparar visores según el tipo de archivo
        if (modalFileType.value === 'image') {
          modalImgbase64.value = base64
        } else if (modalFileType.value === 'pdf') {
          modalPdfSrc.value = base64ToArrayBuffer(base64Data)
        } else if (modalFileType.value === 'text') {
          try {
            const array = base64ToUint8Array(base64Data)
            const decoder = new TextDecoder('utf-8')
            modalTextContent.value = decoder.decode(array)
          } catch (e) {
            try { 
              modalTextContent.value = atob(base64Data) 
            } catch (_) { 
              modalTextContent.value = 'Error al mostrar texto.' 
            }
          }
        } else if (modalFileType.value === 'docx') {
          modalDocxSrc.value = base64ToArrayBuffer(base64Data)
        } else if (modalFileType.value === 'xlsx') {
          modalExcelSrc.value = base64ToArrayBuffer(base64Data)
        } else if (modalFileType.value === 'pptx') {
          modalPptxSrc.value = base64ToArrayBuffer(base64Data)
        } else if (modalFileType.value === 'dwg') {
          modalDwgBase64.value = base64Data
        }
      }

      reader.onerror = () => {
        console.error("Error al leer el archivo.")
      }

      reader.readAsDataURL(file)
    }

    const eliminarArchivo = () => {
      archivo.value = null
      
      // Limpiar visores del modal
      modalFileType.value = ''
      modalTextContent.value = ''
      modalDocxSrc.value = ''
      modalExcelSrc.value = ''
      modalPptxSrc.value = ''
      modalPdfSrc.value = ''
      modalImgbase64.value = ''
      modalDwgBase64.value = ''
    }

    const getFileTypeFromExtension = (extension) => {
      const ext = extension.toLowerCase().replace('.', '')
      if (ext === 'pdf') return 'pdf'
      if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext)) return 'image'
      if (['txt', 'log', 'md'].includes(ext)) return 'text'
      if (['docx'].includes(ext)) return 'docx'
      if (['xlsx', 'csv', 'xls'].includes(ext)) return 'xlsx'
      if (['pptx'].includes(ext)) return 'pptx'
      if (['dwg', 'dxf'].includes(ext)) return 'dwg'
      return 'other'
    }

    const base64ToArrayBuffer = (base64) => {
      const binaryString = atob(base64)
      const len = binaryString.length
      const bytes = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes.buffer
    }

    const base64ToUint8Array = (base64) => {
      const binaryString = atob(base64)
      const len = binaryString.length
      const bytes = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes
    }

    const formatearNombrePropiedad = (nombre) => {
      if (!nombre) return ''
      return nombre.replace(/_/g, ' ')
    }

    const formatDecimal = (value, digits) => {
      return value ? parseFloat(value).toFixed(digits) : ""
    }

    // Manejar input del campo decimal: convertir coma a punto para type="number"
    const handleDecimalInput = (campo, event) => {
      let inputValue = event.target.value
      
      // Si contiene coma, convertirla a punto para que type="number" la acepte
      if (inputValue.includes(',')) {
        inputValue = inputValue.replace(',', '.')
        // Actualizar el valor del input directamente
        event.target.value = inputValue
      }
      
      // Actualizar el modelo con el valor numérico
      if (inputValue === '' || inputValue === null || inputValue === undefined) {
        nuevoRegistro.value[campo] = null
      } else {
        const numValue = parseFloat(inputValue)
        nuevoRegistro.value[campo] = isNaN(numValue) ? null : numValue
      }
    }

    const formatDecimalOnBlur = (campo, digits) => {
      const value = nuevoRegistro.value[campo]
      if (value !== null && value !== undefined && value !== '') {
        // Convertir coma a punto para el parsing
        const normalizedValue = String(value).replace(',', '.')
        const parsedValue = parseFloat(normalizedValue)
        if (!isNaN(parsedValue)) {
          nuevoRegistro.value[campo] = parseFloat(parsedValue.toFixed(digits))
        }
      }
    }

    // Función para cargar valores de una lista (una sola petición por lista_id)
    const cargarValoresLista = async (listaId) => {
      if (!listaId || valoresListasCache.value[listaId]) return
      if (valoresListasPending.value[listaId]) return valoresListasPending.value[listaId]

      const promise = (async () => {
        try {
          const response = await axiosInstance.get(`/api/listas/${listaId}/valores`)
          const valores = response.data.data?.lista?.valores ?? response.data.lista?.valores ?? []
          valoresListasCache.value[listaId] = valores
          return valores
        } catch (error) {
          console.error(`Error al obtener valores de la lista ${listaId}:`, error)
          valoresListasCache.value[listaId] = []
          return []
        } finally {
          delete valoresListasPending.value[listaId]
        }
      })()
      valoresListasPending.value[listaId] = promise
      return promise
    }

    // Función para obtener valores de una lista (síncrona, usa cache)
    const obtenerValoresLista = (listaId) => {
      if (!listaId) return []
      
      // Si no están en cache, iniciar carga asíncrona
      if (!valoresListasCache.value[listaId]) {
        cargarValoresLista(listaId)
        return [] // Retornar vacío mientras carga
      }
      
      return valoresListasCache.value[listaId] || []
    }

    const valoresListaFiltrados = (propiedad) => {
      const valores = obtenerValoresLista(propiedad.lista_id)
      const q = (listFilterText.value || '').trim().toLowerCase()
      if (!q) return valores
      return valores.filter(v => (v.descripcion || '').toLowerCase().includes(q))
    }

    const toggleListDropdown = (propiedad) => {
      if (openListCampo.value === propiedad.campoBD) {
        openListCampo.value = null
        listFilterText.value = ''
        clearListOutsideClick()
        return
      }
      clearListOutsideClick()
      openListCampo.value = propiedad.campoBD
      listFilterText.value = ''
      nextTick(() => {
        const el = document.querySelector(`[data-list-dropdown-modal="${propiedad.campoBD}"]`)
        const input = el?.querySelector('input')
        if (input) input.focus()
        const handler = (e) => {
          if (el && !el.contains(e.target)) {
            openListCampo.value = null
            listFilterText.value = ''
            clearListOutsideClick()
          }
        }
        listOutsideClickHandler = handler
        listOutsideClickTimeout = setTimeout(() => document.addEventListener('click', handler), 0)
      })
    }

    const selectValorLista = (propiedad, valor) => {
      nuevoRegistro.value[propiedad.campoBD] = valor.descripcion
      openListCampo.value = null
      listFilterText.value = ''
      clearListOutsideClick()
    }

    watch(openListCampo, (val) => {
      if (!val) clearListOutsideClick()
    })

    // Computed property para agrupar propiedades por grupo y ordenarlas
    const propiedadesAgrupadas = computed(() => {
      if (!props.esquema?.propiedades) return []

      // Agrupar propiedades por grupo
      const grupos = {}
      props.esquema.propiedades.forEach(propiedad => {
        const grupoNombre = propiedad.grupo || 'Sin grupo'
        if (!grupos[grupoNombre]) {
          grupos[grupoNombre] = {
            nombre: grupoNombre,
            propiedades: []
          }
        }
        grupos[grupoNombre].propiedades.push(propiedad)
      })

      // Convertir a array y ordenar grupos por nombre
      const gruposArray = Object.values(grupos).sort((a, b) => {
        if (a.nombre === 'Sin grupo') return 1
        if (b.nombre === 'Sin grupo') return -1
        return a.nombre.localeCompare(b.nombre)
      })

      // Ordenar propiedades dentro de cada grupo por la propiedad 'orden'
      gruposArray.forEach(grupo => {
        grupo.propiedades.sort((a, b) => (a.orden || 0) - (b.orden || 0))
      })

      return gruposArray
    })

    const validarPropiedadesObligatorias = () => {
      const propiedadesObligatorias = props.esquema.propiedades.filter(prop => prop.obligatorio)
      const errores = []

      propiedadesObligatorias.forEach(prop => {
        const valor = nuevoRegistro.value[prop.campoBD]
        
        if (valor === null || valor === undefined || valor === '' || 
            (typeof valor === 'string' && valor.trim() === '')) {
          errores.push(`La propiedad "${formatearNombrePropiedad(prop.nombre)}" es obligatoria`)
        }
      })

      return errores
    }

    const crearRegistro = async () => {
      // Validar propiedades obligatorias antes de guardar
      const erroresValidacion = validarPropiedadesObligatorias()
      
      if (erroresValidacion.length > 0) {
        // Mostrar todos los errores en una sola notificación
        const mensajeCompleto = erroresValidacion.join('\n• ')
        props.showNotification(`Errores de validación:\n• ${mensajeCompleto}`, 'alert-warning')
        return
      }

      // Emitir el evento con los datos actuales - el manejo de errores se hace en el componente padre
      // NO limpiar aquí, el padre limpiará solo si fue exitoso
      emit('crear-registro', {
        registro: nuevoRegistro.value,
        archivo: archivo.value
      })
    }

    const cerrarModal = () => {
      emit('cerrar-modal')
    }

    // Inicializar nuevoRegistro cuando cambie el esquema
    const inicializarNuevoRegistro = () => {
      if (props.esquema.propiedades) {
        Object.assign(nuevoRegistro, {
          value: props.esquema.propiedades.reduce((acc, columna) => {
            acc[columna.campoBD] = ""
            return acc
          }, {})
        })
      }
    }

    // Inicializar cuando se monta el componente
    inicializarNuevoRegistro()

    // Función para limpiar el formulario y el archivo
    const limpiarFormulario = () => {
      // Limpiar el archivo
      if (archivo.value) {
        // Revocar la URL del objeto si existe
        if (archivo.value.url) {
          URL.revokeObjectURL(archivo.value.url)
        }
        archivo.value = null
      }
      
      // Limpiar visores del modal
      modalFileType.value = ''
      modalTextContent.value = ''
      modalDocxSrc.value = ''
      modalExcelSrc.value = ''
      modalPptxSrc.value = ''
      modalPdfSrc.value = ''
      modalImgbase64.value = ''
      
      // Limpiar el input de archivo
      if (fileInput.value) {
        fileInput.value.value = ''
      }
      
      // Limpiar los inputs del formulario
      if (props.esquema.propiedades) {
        props.esquema.propiedades.forEach(propiedad => {
          nuevoRegistro.value[propiedad.campoBD] = ""
        })
      }
    }

    // Listener para limpiar el formulario cuando se cierra el modal de Bootstrap
    const handleModalHidden = (event) => {
      // Solo limpiar si el modal se cerró después de un guardado exitoso
      // Usaremos un flag para saber si debemos limpiar
      if (event.target.id === 'modalNuevoRegistro') {
        // Verificar si hay un atributo data que indique que fue exitoso
        const shouldClean = event.target.getAttribute('data-clean-on-close')
        if (shouldClean === 'true') {
          limpiarFormulario()
          event.target.removeAttribute('data-clean-on-close')
        }
      }
    }

    onMounted(() => {
      // Agregar listener al evento 'hidden.bs.modal' de Bootstrap
      const modalElement = document.getElementById('modalNuevoRegistro')
      if (modalElement) {
        modalElement.addEventListener('hidden.bs.modal', handleModalHidden)
      }
    })

    onBeforeUnmount(() => {
      // Remover listener al desmontar el componente
      const modalElement = document.getElementById('modalNuevoRegistro')
      if (modalElement) {
        modalElement.removeEventListener('hidden.bs.modal', handleModalHidden)
      }
    })

    // Exponer la función para que el componente padre pueda llamarla
    defineExpose({
      limpiarFormulario
    })

    return {
      archivo,
      isDragging,
      fileInput,
      nuevoRegistro,
      openListCampo,
      listFilterText,
      modalFileType,
      modalTextContent,
      modalDocxSrc,
      modalExcelSrc,
      modalPptxSrc,
      modalPdfSrc,
      modalImgbase64,
      triggerFileInput,
      handleDrop,
      handleFileInput,
      procesarArchivo,
      eliminarArchivo,
      formatearNombrePropiedad,
      formatDecimal,
      formatDecimalOnBlur,
      handleDecimalInput,
      obtenerValoresLista,
      valoresListaFiltrados,
      toggleListDropdown,
      selectValorLista,
      crearRegistro,
      cerrarModal,
      propiedadesAgrupadas
    }
  }
}
</script>

<style scoped>
/* Evitar que el accordion recorte el dropdown de listas */
.accordion-dropdown-open .accordion-item {
  overflow: visible !important;
}
.accordion-dropdown-open .accordion-collapse {
  overflow: visible !important;
}
.accordion-dropdown-open .accordion-body {
  overflow: visible !important;
}
.list-dropdown-open {
  z-index: 1100;
  position: relative;
}

.pdf-container {
  height: 70vh;
  width: 100%;
  overflow: auto;
  border: 1px solid #ccc;
}

.image-container img {
  max-width: 100%;
  height: auto;
}

.file-container {
  margin-top: 16px;
}

.labelFile {
  cursor: pointer;
  display: block;
}

.labelFile:hover {
  opacity: 0.8;
}

/* Estilos para el accordion de propiedades */
.accordion-item {
  border: 1px solid #dee2e6;
  margin-bottom: 8px;
  border-radius: 0.375rem;
  overflow: hidden;
}

.accordion-item:last-child {
  margin-bottom: 0;
}

.accordion-button {
  background-color: #f8f9fa;
  border: none;
  border-radius: 0.375rem;
  font-weight: 500;
  color: #495057;
  padding: 1rem 1.25rem;
}

.accordion-button:not(.collapsed) {
  background-color: #e9ecef;
  color: #212529;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.accordion-button:focus {
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  border-color: #86b7fe;
}

.accordion-button::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
  transition: transform 0.2s ease-in-out;
  width: 1.25rem;
  height: 1.25rem;
  margin-left: auto;
}

.accordion-button:not(.collapsed)::after {
  transform: rotate(180deg);
}

.accordion-body {
  padding: 1.25rem;
  background-color: #fff;
}

.accordion-collapse {
  border-top: 1px solid #dee2e6;
}
</style>
